export default __webpack_public_path__ + "static/media/cbbh.b0baa44a.png";